<template>
  <v-card class="ma-0">
    <v-toolbar dense elevation="1" v-if="isAllAddMode">
      <v-spacer />
      <v-toolbar-title>
        ユニット作成
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="clearAll" v-on="on"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </template>
        <span>閉じる</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <validate-observer ref="observer">
          <v-row>
            <v-col>
              <validate-provider
                v-slot="{ errors }"
                name="type"
                rules="selectInput"
              >
                <v-combobox
                  v-model="unitDraft"
                  :items="units"
                  item-text="name"
                  label="ユニット名を作成 or 選択"
                  prepend-icon="mdi-orbit"
                  multiple
                  chips
                  :error-messages="errors"
                >
                </v-combobox>
              </validate-provider>
            </v-col>
          </v-row>
          <v-row v-if="isAllAddMode">
            <v-col>
              <validate-provider
                v-slot="{ errors }"
                name="type"
                rules="selection"
              >
                <v-select
                  v-model="selectedDevices"
                  :items="devices"
                  item-text="name"
                  label="登録するデバイス"
                  prepend-icon="mdi-camera"
                  return-object
                  multiple
                  chips
                  :error-messages="errors"
                >
                  <template v-slot:item="{ item, attrs }">
                    <v-list-item-action>
                      <v-checkbox :input-value="attrs.inputValue" />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        <span class="text-caption grey--text mr-2">
                          デバイス
                        </span>
                      </v-list-item-subtitle>
                      <v-list-item-title>
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </validate-provider>
            </v-col>
          </v-row>
        </validate-observer>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="warning" outlined @click="clearAll">
        キャンセル
      </v-btn>
      <v-btn color="success" outlined @click="saveDeviceUnit()">
        追加
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { deviceFunctionsMixin } from '@/plugins/mixins'
import { ValidateObserver, ValidateProvider } from '@/plugins/validators'
import { uniq } from 'lodash/array'
import { addDeviceUnit } from '@/firebaseAccess/firestoreAccess'
const wait = ms => new Promise(resolve => setTimeout(resolve, ms))

export default {
  name: 'DeviceUnitEditDialog',
  mixins: [deviceFunctionsMixin],
  props: {
    units: {
      type: Array,
      required: true
    },
    devices: {
      type: Array,
      required: true
    },
    selectedDevice: {
      type: Object,
      required: false
    },
    isAllAddMode: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ValidateProvider,
    ValidateObserver
  },
  data: () => ({
    selectedDevices: [],
    unitDraft: [],
    deviceDraft: {},
    newUnits: []
  }),
  computed: {
    ...mapGetters({
      userId: 'users/getActiveUserId'
    })
  },
  methods: {
    clearDraftUnit() {
      this.unitDraft = []
      this.selectedDevices = []
    },
    clearAll() {
      this.$emit('clickClear')
      this.clearDraftUnit()
    },
    async saveDeviceUnit() {
      // add validation here
      const unitIds = []
      for (const unit of this.unitDraft) {
        if (typeof unit !== 'object') {
          await wait(30)
          const unitDraft = {
            owner: this.userId,
            name: unit
          }
          const newUnit = await addDeviceUnit(unitDraft, true)
          unitIds.push(newUnit.id)
        } else {
          unitIds.push(unit.id)
        }
      }

      if (this.isAllAddMode) {
        const devicesDraft = this.selectedDevices
        for (const device of devicesDraft) {
          device.units = uniq(device.units.concat(unitIds)).filter(
            u => u !== ''
          )
          this.$emit('updateDevice', device)
        }
      } else {
        const device = this.selectedDevice
        device.units = uniq(device.units.concat(unitIds)).filter(u => u !== '')
        this.$emit('updateDevice', device)
      }
      this.clearAll()
      this.clearDraftUnit()
    }
  }
}
</script>
